import React, { useState } from 'react'
import axios from 'axios';
import API_URL from '../../../ApiUrl';
import { FormatRupiah } from '../services/FormatRupiah';
import { useHistory } from 'react-router-dom';
import Swal from 'sweetalert2'

const Payment = ({ isMember, activeStep, ongkir, items, order, registrasi }) => {
    const history = useHistory();
    const [snapToken, setSnapToken] = useState('');
    const [isProcessing, setIsProcessing] = useState(false);

    const isPaymentStep = (isMember && activeStep === 3) || (!isMember && activeStep === 2);
    const showOngkir    = activeStep >= 1;

    const handleMidtrans = () => {
        setIsProcessing(true);
        order.total           = ongkir.total;
        order.code_konsultan  = registrasi.code_konsultan;

        if (snapToken === '') {
            axios({
                method:  'POST',
                url:     API_URL.superStudent2 + '/niec-merchandise/checkout',
                data:    order,
                headers: {},
            })
            .then(res => {
                setSnapToken(res.data.data);
                window.snap.pay(res.data.data, {
                    onSuccess: () => {
                        localStorage.removeItem('react-use-cart');
                        Swal.fire({
                            title:             'Terima Kasih! 🎉',
                            text:              'Pesananmu sudah kami terima dan segera diproses.',
                            icon:              'success',
                            confirmButtonText: 'Kembali ke Toko',
                            confirmButtonColor:'#f03e3e',
                        }).then(() => history.push('/merchandise'));
                    },
                    onPending: () => {
                        Swal.fire({
                            title: 'Pembayaran Pending',
                            text:  'Selesaikan pembayaranmu sesegera mungkin.',
                            icon:  'warning',
                        });
                        history.push('/merchandise');
                    },
                    onError: (result) => {
                        console.log(result);
                        Swal.fire({ title: 'Pembayaran Gagal', icon: 'error' });
                    },
                });
            })
            .catch(err => console.log(err))
            .finally(() => setIsProcessing(false));
        } else {
            window.snap.pay(snapToken, {
                onSuccess: () => { Swal.fire({ title: 'Berhasil!', icon: 'success' }); },
                onPending: (result) => { console.log(result); },
                onError:   (result) => { console.log(result); },
            });
            setIsProcessing(false);
        }
    };

    return (
        <div className="co-summary-card">
            {/* Header */}
            <div className="co-summary-header">
                <i className="bi bi-receipt me-2" />
                <h4 className="co-summary-title">Ringkasan Pesanan</h4>
            </div>

            {/* Item List */}
            <div className="co-summary-items">
                {items?.map((prod, i) => (
                    <div key={i} className="co-summary-item">
                        <div className="co-summary-item-info">
                            <span className="co-summary-item-name">{prod.name}</span>
                            <span className="co-summary-item-qty">x{prod.quantity}</span>
                        </div>
                        <span className="co-summary-item-price">{FormatRupiah(prod.value)}</span>
                    </div>
                ))}
            </div>

            <div className="co-summary-divider" />

            {/* Shipping */}
            {showOngkir && (
                <div className="co-summary-row">
                    <span className="co-summary-label">
                        <i className="bi bi-truck me-1" />Ongkos Kirim
                    </span>
                    <span className="co-summary-value">
                        {ongkir.ongkir > 0 ? FormatRupiah(ongkir.ongkir) : '—'}
                    </span>
                </div>
            )}

            <div className="co-summary-divider" />

            {/* Total */}
            <div className="co-summary-total-row">
                <span className="co-summary-total-label">Total</span>
                <span className="co-summary-total-value">{FormatRupiah(ongkir.total)}</span>
            </div>

            {/* Pay Button */}
            {isPaymentStep && (
                <button
                    className="co-btn-pay"
                    onClick={handleMidtrans}
                    disabled={isProcessing}
                >
                    {isProcessing
                        ? <><span className="spinner-border spinner-border-sm me-2" role="status" />Memproses...</>
                        : <><i className="bi bi-credit-card-fill me-2" />Bayar Sekarang</>
                    }
                </button>
            )}

            {/* Trust Badges */}
            <div className="co-summary-trust">
                <span><i className="bi bi-shield-check me-1" />Pembayaran Aman</span>
                <span><i className="bi bi-lock-fill me-1" />Data Terenkripsi</span>
            </div>
        </div>
    );
};

export default Payment;